import React, { useState } from 'react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import Acente_Anasayfa from './Acente_Anasayfa';
import Acente_TalepOlustur from './Acente_TalepOlustur';
import Acente_Taleplerim from './Acente_Taleplerim';
import {
  BuildingOfficeIcon,
  PlusIcon,
  ListBulletIcon,
  ArrowRightOnRectangleIcon,
  CalendarIcon,
  ClockIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';

const Acente_Layout = ({ onLogout, user }) => {
  const location = useLocation();
  const [currentTime, setCurrentTime] = useState(new Date());

  // Saati güncelle
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  
  const navigation = [
    { name: 'Anasayfa', href: '/agency', icon: BuildingOfficeIcon },
    { name: 'Talep Oluştur', href: '/agency/talep-olustur', icon: PlusIcon },
    { name: 'Taleplerim', href: '/agency/taleplerim', icon: ListBulletIcon },
    { name: 'Raporlar', href: '/agency/raporlar', icon: ChartBarIcon },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white/80 backdrop-blur-sm border-b border-white/20 shadow-sm">
        <div className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8">
          {/* 3 Grup Layout - Sol: Acente İsmi, Orta: Tab'lar, Sağ: Tarih/Saat/Çıkış */}
          <div className="flex items-center justify-between py-4">
            {/* Sol Grup - Acente İsmi */}
            <div className="flex items-center">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center">
                  <BuildingOfficeIcon className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">
                    {user?.agency_name || 'Acente Portalı'}
                  </h1>
                  <p className="text-sm text-gray-500">BHT Clinic Transfer Sistemi</p>
                </div>
              </div>
            </div>
            
            {/* Orta Grup - Tab Navigation */}
            <div className="flex items-center">
              <div className="flex">
                {navigation.map((item) => {
                  const isActive = location.pathname === item.href;
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition-all duration-200 border-b-2 ${
                        isActive
                          ? 'text-red-600 border-red-600 bg-red-50/50'
                          : 'text-gray-600 border-transparent hover:text-gray-800 hover:border-gray-300'
                      }`}
                    >
                      <item.icon className="h-4 w-4" />
                      {item.name}
                    </Link>
                  );
                })}
              </div>
            </div>
            
            {/* Sağ Grup - Tarih, Saat ve Çıkış */}
            <div className="flex items-center gap-6">
              {/* Tarih ve Saat */}
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <CalendarIcon className="h-4 w-4" />
                  <span>{currentTime.toLocaleDateString('tr-TR', { 
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric',
                    weekday: 'long'
                  })}</span>
                </div>
                <div className="flex items-center gap-2">
                  <ClockIcon className="h-4 w-4" />
                  <span>{currentTime.toLocaleTimeString('tr-TR', { 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    second: '2-digit' 
                  })}</span>
                </div>
              </div>
              
              <button
                onClick={onLogout}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors px-3 py-2 rounded-md hover:bg-gray-100"
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5" />
                Çıkış
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Main Content */}
        <Routes>
          <Route path="/" element={<Acente_Anasayfa user={user} />} />
          <Route path="/talep-olustur" element={<Acente_TalepOlustur user={user} />} />
          <Route path="/taleplerim" element={<Acente_Taleplerim user={user} />} />
          <Route path="/raporlar" element={
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Raporlar</h2>
              <p className="text-gray-600">Raporlar sayfası yakında eklenecek...</p>
            </div>
          } />
        </Routes>
      </div>
    </div>
  );
};

export default Acente_Layout;
